import { useLang } from '@/app/utils/useLang';
import { getSolarRecommand } from '@/service/solar-calculator';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoCompareProduct from 'eco-design/sections/eco-compare-product';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import styles from './index.module.scss';

const Comparison: React.FC = () => {
    const { t } = useLang('Comparison');
    const { locale = 'us' } = useRouter();
    const [list, setList] = useState();

    const isEU = ['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale);

    const contentLength = isEU ? 10 : 13;

    const specItems = (row: number) => {
        return [...new Array(contentLength)].map((item, index) => {
            return {
                desc: t(`item${row + 1}_desc${index + 1}`) || t(`item_desc${index + 1}`),
                title: t(`item${row + 1}_title${index + 1}`),
            };
        });
    };

    // 按区域和产品ID组织配置
    const PRODUCT_CONFIG = {
        us: {
            item1: { productId: '15386147061833', variantId: '54718699962441' },
            item2: { productId: '15386147061833', variantId: '54692162764873' },
            item3: { productId: '6905537888329', variantId: '54615943512137' },
        },
        ca: {
            item1: { productId: '15164532654451', variantId: '62106661618035' },
            item2: { productId: '15164532654451', variantId: '62060638372211' },
            item3: { productId: '7825964400794', variantId: '43592212775066' },
        },
        eu: {
            item1: { productId: '10301812244823', variantId: '51787034460503' },
            item2: { productId: '10301812244823', variantId: '51787034558807' },
            item3: { productId: '8414996627799', variantId: '46790633881943' },
        },
        de: {
            item1: { productId: '15562538451325', variantId: '57020101198205' },
            item2: { productId: '15562538451325', variantId: '57020101296509' },
            item3: { productId: '8513034813775', variantId: '46739567706447' },
        },
        fr: {
            item1: { productId: '10110678139227', variantId: '51408464904539' },
            item2: { productId: '10110678139227', variantId: '51408465002843' },
            item3: { productId: '8431233794395', variantId: '46793751789915' },
        },
        it: {
            item1: { productId: '14969542836600', variantId: '55289474154872' },
            item2: { productId: '14969542836600', variantId: '55289474253176' },
            item3: { productId: '8415773360477', variantId: '46891073274205' },
        },
        es: {
            item1: { productId: '10110680498523', variantId: '51408468738395' },
            item2: { productId: '10110680498523', variantId: '51408468836699' },
            item3: { productId: '8435033899355', variantId: '46787970269531' },
        },
        uk: {
            item1: { productId: '10279052902739', variantId: '52472460542291' },
            item2: { productId: '10279052902739', variantId: '52472460640595' },
            item3: { productId: '8416984367443', variantId: '46679851139411' },
        },
    };

    const getProductConfig = (itemName: any) => PRODUCT_CONFIG[locale]?.[itemName] || PRODUCT_CONFIG.us[itemName];

    let items = [
        {
            subItems: [
                {
                    title: t('item1_title'),
                    // desc: t('item1_desc'),
                    lChildren: t('link_buy'),
                    lDataLayer: {
                        __btn_type: 'href',
                        __btn_id1: `range6 .__item-1 .l-item-btn`,
                        event: 'uaEvent',
                        event_name: 'checkout',
                        button_name: `${t('link_buy')}`,
                        page_name: 'EcoFlow DELTA 3 Max Plus',
                    },
                    rChildren: t('link_more'),
                    rHref: isEU
                        ? `https://${locale}.ecoflow.com/products/delta-3-max-series-portable-power-station`
                        : `https://${locale}.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=${getProductConfig('item1').variantId}`,
                    rDataLayer: {
                        __btn_type: 'href',
                        __btn_id1: `range6 .__item-1 .r-item-btn`,
                        event: 'uaEvent',
                        event_name: 'buy',
                        position: t('link_more'),
                    },
                    productId: getProductConfig('item1').productId,
                    variantId: getProductConfig('item1').variantId,
                    specItems: specItems(0),
                },
            ],
        },
        {
            subItems: [
                {
                    title: t('item2_title'),
                    // desc: t('item2_desc'),
                    lChildren: t('link_buy'),
                    lDataLayer: {
                        __btn_type: 'href',
                        __btn_id1: `range6 .__item-2 .l-item-btn`,
                        event: 'uaEvent',
                        event_name: 'checkout',
                        button_name: `${t('link_buy')}`,
                        page_name: 'EcoFlow DELTA 3 Max Plus',
                    },
                    rChildren: t('link_more'),
                    rHref: isEU
                        ? `https://${locale}.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=${getProductConfig('item2').variantId}`
                        : `https://${locale}.ecoflow.com/products/delta-3-max-series-portable-power-station`,
                    rDataLayer: {
                        __btn_type: 'href',
                        __btn_id1: `range6 .__item-2 .r-item-btn`,
                        event: 'uaEvent',
                        event_name: 'buy',
                        position: t('link_more'),
                    },
                    productId: getProductConfig('item2').productId,
                    variantId: getProductConfig('item2').variantId,
                    specItems: specItems(1),
                },
            ],
        },
        {
            subItems: [
                {
                    title: t('item3_title'),
                    // desc: t('item3_desc'),
                    lChildren: t('link_buy'),
                    lDataLayer: {
                        __btn_type: 'href',
                        __btn_id1: `range6 .__item-3 .l-item-btn`,
                        event: 'uaEvent',
                        event_name: 'checkout',
                        button_name: t('link_buy'),
                        page_name: 'EcoFlow DELTA 3 Max Plus',
                    },
                    rChildren: t('link_more'),
                    rHref: isEU ? `https://${locale}.ecoflow.com/products/delta-2-max-portable-power-station?variant=${getProductConfig('item3').variantId}` : `https://${locale}.ecoflow.com/products/delta-2-max-portable-power-station`,
                    rDataLayer: {
                        __btn_type: 'href',
                        __btn_id1: `range6 .__item-3 .r-item-btn`,
                        event: 'uaEvent',
                        event_name: 'buy',
                        position: t('link_more'),
                    },
                    productId: getProductConfig('item3').productId,
                    variantId: getProductConfig('item3').variantId,
                    specItems: specItems(2),
                },
            ],
        },
    ];

    const getAsynItem = async (productId: string, variantId: string) => {
        return await new Promise(async (resolve, reject) => {
            try {
                const res = await getSolarRecommand({ productId, variantId }, locale);
                if (res?.code === '0') {
                    return resolve(res);
                } else {
                    console.error(res?.message);
                    return reject(res?.message);
                }
            } catch (e) {
                console.error(e);
                return reject(e);
            }
        });
    };

    useEffect(() => {
        const promises = items?.map((item: any) => getAsynItem(item?.subItems[0].productId, item.subItems[0].variantId));
        Promise.all(promises).then((res) => {
            const old = JSON.parse(JSON.stringify(items));
            const list = res.map((i: any, idx) => {
                const notSaleList = [2];
                const variantId = getProductConfig(`item${idx + 1}`).variantId;
                if (i.data.variantImg) {
                    old[idx].subItems[0].pc = i.data.variantImg;
                }

                if (i.data.inventoryQuantity === 0) {
                    old[idx].subItems[0].lChildren = t(`link_sold`);
                    old[idx].subItems[0].lDisabled = true;
                }
                const title = notSaleList.includes(idx) ? t('item3_title') : i.data.skuTitle?.split(' / ')[0];
                old[idx].subItems[0].title = title;
                // old[idx].subItems[0].lDataLayer.button_name = `${old[idx].subItems[0].lDataLayer.button_name}_${title}`;
                old[idx].subItems[0].lDataLayer.product_name = title;
                old[idx].subItems[0].rDataLayer.product_name = title;
                // old[idx].subItems[0].lHref = notSaleList.includes(idx)
                //     ? `https://${locale}.ecoflow.com/products/delta-2-max-portable-power-station`
                //     : `https://${locale}.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=${variantId}`;

                old[idx].subItems[0].lHref = `https://${locale}.ecoflow.com/cart/${variantId}:1?channel=buy_button`;
                old[idx].subItems[0].lDataLayer.__btn_id2 = old[idx].subItems[0].lHref;
                old[idx].subItems[0].rDataLayer.__btn_id2 = old[idx].subItems[0].rHref;
                return old[idx];
            });
            items = JSON.parse(JSON.stringify(list));
            setList(list as any);
        });
    }, []);

    return (
        <div className={`page-comparison ${styles.Comparison} GtmModuleData-section`} data-section-id="d3m-comparison" id="d3m-comparison">
            <EcoSectionCommon title={t('title')} />
            {!!list && <EcoCompareProduct items={list} isOpenLazy={true}></EcoCompareProduct>}
        </div>
    );
};

export default Comparison;
